import "@/App.css";
import { Toaster } from "sonner";

import LenisProvider from "@/components/portfolio/LenisProvider";
import Nav from "@/components/portfolio/Nav";
import Hero from "@/components/portfolio/Hero";
import About from "@/components/portfolio/About";
import Journey from "@/components/portfolio/Journey";
import EditorialMarquee from "@/components/portfolio/Marquee";
import AmiOne from "@/components/portfolio/AmiOne";
import YourHomes from "@/components/portfolio/YourHomes";
import Achievements from "@/components/portfolio/Achievements";
import Philosophy from "@/components/portfolio/Philosophy";
import Technology from "@/components/portfolio/Technology";
import Insights from "@/components/portfolio/Insights";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import WhatsAppFab from "@/components/portfolio/WhatsAppFab";

function App() {
  return (
    <LenisProvider>
      <div className="App grain-overlay min-h-screen bg-ink-950 text-ivory selection:bg-copper selection:text-ink-950">
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <About />
          <Journey />
          <AmiOne />
          <EditorialMarquee />
          <YourHomes />
          <Achievements />
          <Philosophy />
          <Technology />
          <Insights />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFab />
        <Toaster
          theme="light"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#EDE6D8",
              border: "1px solid rgba(42,30,20,0.10)",
              color: "#2A1E14",
              fontFamily: "'Manrope', sans-serif",
              fontSize: 13,
            },
          }}
        />
      </div>
    </LenisProvider>
  );
}

export default App;
